<!-- <header>
  <div class="header-down-wrapper-other">
     <img [hidden]="fromMobileApp" class="bajaj-logo" src="./assets/img/Bajaj Finserv_white-01.svg">
    
  <section class="pg-home">
    <div >
    <div class="container-fluid">
      <div class="line-wrapper">
      <div class="banner-text-holder">
          <div *ngIf="!consentTokenAvailable" class="banner-bar-holder">
            <span class="banner-horizontal-yellowbar"></span>
            <span class="banner-vertical-yellowbar"></span>
          </div>

           <div *ngIf="securedProductFlag" class="banner-text">
            <h2 class="title text-center heading-white heading-top-margin ">
              <div class="heading-sub-part">
                  Getting Home Loans
                <span class="heading-sub-part">couldn’t be quicker!</span>
              </div>
            </h2>
            <p class="desc text-center">
               Instant approval and Quick Disbursal!
            </p>
          </div> 

           <div *ngIf="!securedProductFlag && !consentTokenAvailable" class="banner-text">
            <h2 class="title text-center heading-white heading-top-margin ">
              <div class="heading-sub-part">
                Getting Personal Loans
                <span class="heading-sub-part">couldn’t be quicker!</span>
              </div>
            </h2>
            <p class="desc text-center">
            Instant Approval and Quick Disbursal!
            </p>
          </div> 

        </div>
      </div>
    </div>
  </div>
  </section>
</div>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</header> -->
<header [ngClass]="{'screen-back-colour': bflOcrIncomeVerification ,'epbitlyUserDetails': epbitly}">
   <!-- <div class="form-page-wrapper">
      <div class="header">
          <img class="logo-b" src="./assets/img/Bajaj_Finserv_light_blue-01.svg" alt="Logo" 
              width="130" />            
      </div>        
      
  </div> -->

  <div class="with-banner" *ngIf="showHeader">
    <!-- <img class="w-100" src="./assets/img/Revised_icons-146.svg" alt="Banner" /> -->
    <!-- <a href="https://bajajfinservmarkets.in"><img *ngIf = "MobParam" class="logo-b" src="./assets/img/White.svg" alt="Logo" /> </a> -->
    <a href="https://bajajfinservmarkets.in"><img *ngIf = "MobParam" class="logo-b" src="{{bajajMarketsLogo}}" alt="Logo" /> </a>

    <div class="corousel-container" *ngIf = '!securedBannerFlag'>
        <img class="hero-baner hidden-xs" width="100%" src="https://www.bajajfinservmarkets.in/content/dam/bajajfinserv/spa-banners/commonoffer/unsecured/Personal_Loan_Desktop.png " alt="Banner" />
        <img class="hero-baner visible-xs" width="100%" src="https://www.bajajfinservmarkets.in/content/dam/bajajfinserv/spa-banners/commonoffer/unsecured/Personal_Loan_Mobile.png " alt="Banner" />
     <!--  <carousel [noPause]="false"  [interval]="10000" [noWrap]="false" class="hidden-xs">
        <slide *ngFor="let banner of customBanners">
            <img class="hero-baner" src="{{banner.imgPath}}" alt="">
        </slide>
      </carousel>
      <carousel [interval]="10000" [noWrap]="false" class="visible-xs">
        <slide *ngFor="let banner of customBanners">
            <a (click)="navigation(banner.isExternal,banner.href)">
                <img class="hero-baner" src="{{banner.imgPathMob}}" alt="">
            </a>
        </slide>
    </carousel> -->
    </div>


    <div class="corousel-container" *ngIf = 'securedBannerFlag'>
      <img class="hero-baner hidden-xs" width="100%" src="https://www.bajajfinservmarkets.in/content/dam/bajajfinserv/spa-banners/commonoffer/secured/Home_Loan_Desktop.png " alt="Banner" />
      <img class="hero-baner visible-xs" width="100%" src="https://www.bajajfinservmarkets.in/content/dam/bajajfinserv/spa-banners/commonoffer/secured/Home_Loan_Mobile.png " alt="Banner" />
   <!--  <carousel [noPause]="false"  [interval]="10000" [noWrap]="false" class="hidden-xs">
      <slide *ngFor="let banner of customBanners">
          <img class="hero-baner" src="{{banner.imgPath}}" alt="">
      </slide>
    </carousel>
    <carousel [interval]="10000" [noWrap]="false" class="visible-xs">
      <slide *ngFor="let banner of customBanners">
          <a (click)="navigation(banner.isExternal,banner.href)">
              <img class="hero-baner" src="{{banner.imgPathMob}}" alt="">
          </a>
      </slide>
  </carousel> -->
  </div>
    <app-loan-progress *ngIf="ShowProgressInfo" [progressState]="ProgressStateInfo">
    </app-loan-progress>
  </div>
  <div *ngIf="bflOcrIncomeVerification" class="header-font header-font">
    <nav class="navbar navbar-default nav-colour d-flex justify-content-start align-items-center mob-nav">
      <div class="d-flex align-items-center">
        <a class="navbar-brand d-flex align-items-center" >
          <img class="icon-style arrow-size" (click)="goBack()" src="assets/img/svg/backword-arrow-white.svg" />
        </a>
        <div>{{headerText}}</div>
      </div>
    </nav>
  </div>

  <div *ngIf="epbitly || userDetails || inprogressScreen" class="header-font header-font">
    <nav class="navbar navbar-default nav-colour  mob-nav epbitlyHeader">
      <div class="d-flex justify-content-between align-items-center w-100 mx-4">
        <div class="d-flex"><img src="assets/img/png/Bajaj_Finserv_white_Logo.png" alt="" style=" width:95px; height:38px;"></div>
        <div *ngIf="inprogressScreen"></div>
        <div *ngIf="epbitly || userDetails">Link Your Bank Account</div>
      </div>
    </nav>
  </div>

  <router-outlet></router-outlet>
  <app-footer *ngIf="showHeader"></app-footer>
</header>
